import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getCycles } from 'src/app/cycle/store/selectors/cycle.selectors';

import { PerformanceModuleState } from '../../models/performance.model';
import { getLatestWeek } from '../reducers/performance.reducer';

export const getPerformanceModuleState =
  createFeatureSelector<PerformanceModuleState>('performanceModule');

export const getSelectedWeekNr = createSelector(
  getPerformanceModuleState,
  (state) => state.selectedWeekNr,
);

export const getSelectedCycleId = createSelector(
  getPerformanceModuleState,
  (state) => state.selectedCycleId,
);

export const getSelectedCycle = createSelector(getCycles, getSelectedCycleId, (cycles, cycleId) =>
  cycles?.find((c) => c.id === cycleId),
);

export const getObservations = createSelector(
  getPerformanceModuleState,
  (state) => state.observations,
);

export const getAvailableSections = createSelector(
  getSelectedCycle,
  (cycle) => cycle?.sections ?? [],
);

export const getSelectedSectionIds = createSelector(
  getPerformanceModuleState,
  (state) => state.selectedSectionIds,
);

export const getSelectedSections = createSelector(
  getAvailableSections,
  getSelectedSectionIds,
  (availableSections, selectedIds) =>
    availableSections
      ?.filter((s) => selectedIds?.indexOf(s.id) >= 0)
      .sort((a, b) => (a.name < b.name ? -1 : 0)),
);

export const getSelectedKpiParameters = createSelector(
  getPerformanceModuleState,
  (state) => state.selectedKpiParameters,
);

export const getAvailableWeeks = createSelector(getObservations, (observations) =>
  observations ? Array.from({ length: getLatestWeek(observations) }, (_, i) => i + 1) : [],
);

export const getWeeklyKpiDataResults = createSelector(
  getPerformanceModuleState,
  (state) => state.weeklyKpiDataResults,
);

export const getDailyKpiTimeseries = createSelector(
  getPerformanceModuleState,
  (state) => state.dailyKpiTimeSeries,
);
